/*=========================================================================================
  File Name: moduleEmailState.js
  Description: Email Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  mails: [
    {
      id: 1,
      inquiry: 'Bitte beschreiben Sie kurz Ihr Forschungsprojekt und erläutern Sie den Zweck der zu entwickelnden Mensch-Technik-Interaktion (MTI).',
      subject: 'Frage-ID 001',
      message: '<p>Zur <a @click.prevent="$emit(\'kblink\', {id: 1})">"Mensch-Technik-Interaktion."</a></p>',
      isStarred: false,
      labels: ['Allgemein'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "text",
        options: [],
        answer: '',
      },
      remark: '',
    },
    {
      id: 2,
      inquiry: 'Beschreiben Sie kurz, welche Interaktionen die Maschine mit Menschen ausführen soll?',
      subject: 'Frage-ID 002',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "text",
        options: [],
        answer: '',
      },
      remark: '',
    },
    {
      id: 3,
      inquiry: 'Wem soll das Forschungsergebnis dienen (z. B. der gesamten Gesellschaft oder einer bestimmten Teilgruppe der Gesellschaft)?',
      subject: 'Frage-ID 003',
      message: '<p> </p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "bigtext",
        options: [],
        answer: '',
      },
      remark: '',
    },
    {
      id: 4,
      inquiry: 'Hilft oder dient das System bzw. Forschungsergebnis einer schutzbedürftigen Gruppe?',
      subject: 'Frage-ID 004',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 29})">"Schutzbedürftigen Gruppen."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "followup-radio",
        options: [
          {name: 'Ja', followupID: 4.1, risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],

        answer: '',
      },
      remark: '',
    },
    {
      id: 4.1,
      inquiry: 'Ist die betroffene schutzbedürftige Gruppe direkt in das Forschungsprojekt involviert (z. B. durch Einbeziehung in das Forschungsprojekt als Probanden)?',
      subject: 'Frage-ID 004.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "radio",
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 5,
      inquiry: 'Ist ein Einsatz oder Vertrieb der MTI in der Privatwirtschaft oder der öffentlichen Verwaltung nach Abschluss des Forschungsprojektes geplant?',
      subject: 'Frage-ID 005',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "radio",
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 6,
      inquiry: 'Handelt es sich bei der MTI um eine Künstliche Intelligenz (KI)?',
      subject: 'Frage-ID 101',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 2})">"Künstlicher Intelligenz."</a></p>',
      isStarred: false,
      labels: ['Allgemein'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "followup-radio",
        options: [
          {name: 'Ja', followupID: 6.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],

        answer: '',
      },
      remark: '',
    },
    {
      id: 6.1,
      inquiry: 'Beschreiben Sie bitte kurz die Funktionsweise der KI.',
      subject: 'Frage-ID 101.1',
      message: `<p></p>`,
      isStarred: false,
      labels: ['Allgemein'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "text",
        options: [],
        answer: '',
      },
      remark: '',
    },
    {
      id: 7,
      inquiry: 'Könnte die MTI/KI Einfluss auf Entscheidungen haben, die einen oder mehrere Menschen benachteiligen?',
      subject: 'Frage-ID 102',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "followup-radio",
        options: [
          {name: 'Ja', followupID: 7.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', followupID: 7.2, risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],

        answer: '',
      },
      remark: '',
    },
    {
      id: 7.1,
      inquiry: 'Sind technische Maßnahmen geplant, die eine mögliche Benachteiligung ausschließen oder minimieren?',
      subject: 'Frage-ID 102.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "radio",
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 7.2,
      inquiry: 'Lässt sich die möglicherweise entstehende Benachteiligung durch den Anwendungszweck nachvollziehbar rechtfertigen?',
      subject: 'Frage-ID 102.2',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "radio",
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 8,
      inquiry: 'Ist die MTI/KI vom Entwickler jederzeit übersteuerbar?',
      subject: 'Frage-ID 103',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "followup-radio",
        options: [
          {name: 'Ja', followupID: 8.1 , risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', followupID: 8.2, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 8.1,
      inquiry: 'Wie stellen Sie die Übersteuerbarkeit der MTI/KI sicher?',
      subject: 'Frage-ID 103.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "text",
        options: [],
        answer: '',
      },
      remark: '',
    },
    {
      id: 8.2,
      inquiry: 'Lässt sich die fehlende Übersteuerbarkeit nachvollziehbar begründen?',
      subject: 'Frage-ID 103.2',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 9,
      inquiry: 'Ist die MTI/KI vom Anwender jederzeit übersteuerbar?',
      subject: 'Frage-ID 104',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 9.1, risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', followupID: 9.2, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 9.1,
      inquiry: 'Wie stellen Sie die Übersteuerbarkeit der MTI/KI durch den Anwender sicher?',
      subject: 'Frage-ID 104.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "text",
        options: [],
        answer: '',
      },
      remark: '',
    },
    {
      id: 9.2,
      inquiry: 'Lässt sich nachvollziehbar begründen, weshalb der Anwender die MTI/KI nicht übersteuern können muss?',
      subject: 'Frage-ID 104.2',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 10,
      inquiry: 'Ist sichergestellt, dass die Repräsentativität in Hinblick auf Daten gewährleistet ist?',
      subject: 'Frage-ID 201',
      message: '<p>Zu: <a @click.prevent="$emit(\'kblink\', {id: 20})">"BIAS."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Gerechtigkeit'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 10.1, risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 10.1,
      inquiry: 'Wie werden die Daten innerhalb Ihres Forschungsprojektes auf mögliche BIAS geprüft?',
      subject: 'Frage-ID 202',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Gerechtigkeit'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "text",
        options: [],
        answer: '',
      },
      remark: '',
    },
    {
      id: 11,
      inquiry: 'Sind Teile oder Aufgaben im Projekt an Dritte ausgelagert?',
      subject: 'Frage-ID 203',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 11.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 11.1,
      inquiry: 'Können Sie die Repräsentativität der Daten im ausgelagerten Teil sicherstellen?',
      subject: 'Frage-ID 203.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 12,
      inquiry: 'Sollen sämtliche Datenzugriffe im Forschungsprojekt schriftlich dokumentiert werden?',
      subject: 'Frage-ID 204',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 13,
      inquiry: 'Wird im Forschungsprojekt geprüft, ob Faktoren (wie z. B. Alter, Geschlecht, sozialer Hintergrund oder Diversität) zielgruppengerecht in den Trainingsdaten abgebildet werden?',
      subject: 'Frage-ID 205',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Fürsorge','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 14,
      inquiry: 'Gibt es unter den Entwickelnden der MTI eine ausreichende Diversität (Geschlecht, Alter, Herkunft etc.)?',
      subject: 'Frage-ID 206',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Gerechtigkeit'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 15,
      inquiry: 'Werden Anwendende informiert, wenn eine signifikante Entscheidung über sie von der MTI/KI getroffen oder unterstützt wurde?',
      subject: 'Frage-ID 301',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 16,
      inquiry: 'Kann die MTI kontinuierlich aktualisiert werden (z. B. durch Updates)?',
      subject: 'Frage-ID 302',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', followupID: 16.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 16.1,
      inquiry: 'Gibt es nachvollziehbare Gründe, die eine regelmäßige Aktualisierung nicht notwendig machen?',
      subject: 'Frage-ID 302.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 17,
      inquiry: 'Kann die Funktionsfähigkeit der MTI/KI regelmäßig überprüft werden?',
      subject: 'Frage-ID 303',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 18,
      inquiry: 'Wird sichergestellt, dass die Entwickelnden die Funktionsweise des Algorithmus vollständig nachvollziehen können?',
      subject: 'Frage-ID 304',
      message: '<p>Zu einem<a @click.prevent="$emit(\'kblink\', {id: 4})">"Algorithmus."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 19,
      inquiry: 'Besteht ein realistisches Risiko, dass eine mangelnde Nachvollziehbarkeit der Funktionsweise Schaden versursachen kann?',
      subject: 'Frage-ID 305',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 19.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 19.1,
      inquiry: 'Ergreifen Sie Maßnahmen, um das Risiko technisch und/oder organisatorisch so gering wie möglich zu halten?',
      subject: 'Frage-ID 305.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 20,
      inquiry: 'Ist sichergestellt, dass die Funktionsweise der MTI/KI dem Anwendenden (d.h. Laien/Nicht-Programmierenden) erklärbar gemacht werden kann?',
      subject: 'Frage-ID 306',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', followupID: 20.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 20.1,
      inquiry: 'Gibt es einen nachvollziehbaren Grund, weshalb die Funktionsweise der MTI/KI für die Anwendenden nicht erklärbar gemacht werden muss?',
      subject: 'Frage-ID 306.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 21,
      inquiry: 'Besteht ein realistisches Risiko, dass durch eine mangelnde Erklärbarkeit für Anwendende ein Schaden entstehen kann?',
      subject: 'Frage-ID 307',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 21.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 1, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 21.1,
      inquiry: 'Ergreifen Sie Maßnahmen, um das Risiko technisch und/oder organisatorisch so gering wie möglich zu halten?',
      subject: 'Frage-ID 307.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 22,
      inquiry: 'Soll der Quellcode des entwickelten Algorithmus bzw. die Funktionsweise der MTI/KI öffentlich zugänglich gemacht oder auf Nachfrage erhältlich sein?',
      subject: 'Frage-ID 308',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', followupID: 22.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 22.1,
      inquiry: 'Existieren nachvollziehbare Gründe, die einer möglichen Veröffentlichung entgegenstehen?',
      subject: 'Frage-ID 308.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 23,
      inquiry: 'Kann bei falschen Entscheidungen oder Ergebnissen der MTI/KI nachvollzogen werden, welche Schlüsselfaktoren zu der falschen Entscheidung bzw. dem falschen Ergebnis geführt haben?',
      subject: 'Frage-ID 309',
      message: '<p> </p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 24,
      inquiry: 'Ist es möglich, dass das Forschungsergebnis von Dritten für unethische Zwecke missbraucht werden kann?',
      subject: 'Frage-ID 401',
      message: '<p>Zum sog.: <a @click.prevent="$emit(\'kblink\', {id: 8})">"Dual Use."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 25,
      inquiry: 'Interagiert das System physisch mit der Außen- bzw. Umwelt?',
      subject: 'Frage-ID 402',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 25.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 25.1,
      inquiry: 'Kann das System physische Schäden verursachen?',
      subject: 'Frage-ID 402.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung',],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 26,
      inquiry: 'Wird im Projektverlauf über mögliche Schäden, die die MTI auslösen kann, nachgedacht?',
      subject: 'Frage-ID 403',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 26.1, risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 26.1,
      inquiry: 'Werden mögliche Auswirkungen der MTI in einer Technikfolgenabschätzung untersucht?',
      subject: 'Frage-ID 403.1',
      message: '<p>Zur<a @click.prevent="$emit(\'kblink\', {id: 4})">"Technikfolgenabschätzung."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 27,
      inquiry: 'Existiert für die MTI im Projektverlauf ein regelmäßiger/standardisierter technischer Prüfzyklus?',
      subject: 'Frage-ID 404',
      message: '<p> </p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', followupID: 27.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 27.1,
      inquiry: 'Gibt es im Projekt andere Maßnahmen, die die technische Robustheit der MTI sicherstellen können?',
      subject: 'Frage-ID 404.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 28,
      inquiry: 'Wird das Projektteam über ethische Grundsätze der Entwicklung von MTI informiert?',
      subject: 'Frage-ID 405',
      message: '<p> </p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Autonomie','Gerechtigkeit','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 29,
      inquiry: 'Gibt es im Projekt einen Ansprechpartner, der sich möglicher Beschwerden zu falschen bzw. unfairen Entscheidungen der MTI annimmt?',
      subject: 'Frage-ID 406',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Gerechtigkeit'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 30,
      inquiry: 'Ist die zu entwickelnde MTI in der praktischen Anwendung geeignet, Ergebnisse oder Daten zu liefern, die gegen Gleichheitsgrundsätze verstoßen könnten?',
      subject: 'Frage-ID 407',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 5})">"Gleichheitsgrundsätzen nach Art. 3 GG."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Gerechtigkeit'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id:31,
      inquiry: 'Kann die MTI dazu geeignet sein, weitere Rechte Dritter zu tangieren oder hierin einzugreifen?',
      subject: 'Frage-ID 408',
      message: '<p>Zur<a @click.prevent="$emit(\'kblink\', {id: 24})">"Drittwirkung von Grundrechten."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Gerechtigkeit'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 31.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 31.1,
      inquiry: 'Welche Grundrechte könnten hier betroffen sein?',
      subject: 'Frage-ID 408.1',
      message: '<p>tbd.</p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Autonomie','Gerechtigkeit'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: "text",
        options: [],
        answer: '',
      },
      remark: '',
    },
    {
      id: 32,
      inquiry: 'Werden in der Entwicklung der MTI die Grundsätze von Privacy-by-Design und Privacy-by-Default berücksichtigt?',
      subject: 'Frage-ID 409',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 17})">"Privacy by Design."</a> und <a @click.prevent="$emit(\'kblink\', {id: 18})">"Privacy by Default."</a></p>',
      isStarred: false,
      labels: ['Datenschutz','Fürsorge','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 33,
      inquiry: 'Werden in der Entwicklung der MTI die Grundsätze von Ethics-by-Design berücksichtigt?',
      subject: 'Frage-ID 410',
      message: '<p>Zu<a @click.prevent="$emit(\'kblink\', {id: 6})">"Ethics-by-Design."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Autonomie','Gerechtigkeit','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 34,
      inquiry: 'Werden in der Entwicklung der MTI der Grundsatz und das Ideal der "digitalen Barrierefreiheit" berücksichtigt?',
      subject: 'Frage-ID 411',
      message: '<p>Zu<a @click.prevent="$emit(\'kblink\', {id: 21})">"digitaler Barrierefreiheit."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Autonomie','Gerechtigkeit'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 35,
      inquiry: 'Könnte die Technologie missbraucht werden, um das Vertrauen in soziale oder gesellschaftliche Institutionen (z. B. Medien, Medizinbereich, Regierungsbehörden) zu schädigen?',
      subject: 'Frage-ID 412',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 36,
      inquiry: 'Könnte die Technologie missbraucht werden, um anderen Menschen Schaden zuzufügen oder illegale Aktivitäten (z. B. Stalking, Mobbing, Finanzbetrug, Diebstahl) zu fördern?',
      subject: 'Frage-ID 413',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 37,
      inquiry: 'Gibt es Bevölkerungsgruppen, die aufgrund ihrer sozialen Herkunft oder finanziell verfügbaren Mitteln von der Nutzung der MTI faktisch ausgeschlossen sein könnten?',
      subject: 'Frage-ID 414',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Gerechtigkeit'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 38,
      inquiry: 'Sollen durch die MTI personenbezogene Daten verarbeitet werden?',
      subject: 'Frage-ID 501',
      message: '<p>Zu<a @click.prevent="$emit(\'kblink\', {id: 11})">"personenbezogenen Daten nach der DSGVO."</a> </p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      // Filter: Optional array of objects
      filter: [
        {
          title: 'Ja',
          includes: [
            'Allgemein',
            'Datenschutz'
          ],
          excludes: [
            '',
          ],
          active: false
        },
        {
          title: 'nein',
          includes: [
            'Allgemein',
          ],
          excludes: [
            'Datenschutz',
          ],
          active: false
        },
      ],
      answer: {
        type: 'filter',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 39,
      inquiry: 'Ist bereits absehbar, wer in einem späteren praktischen Systembetrieb als Datenverantwortlicher anzusehen wäre?',
      subject: 'Frage-ID 502',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 7})">"Art. 4. Abs. 7 DSGVO."</a> </p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 40,
      inquiry: 'Wären hier mehrere Datenverarbeiter beteiligt?',
      subject: 'Frage-ID 503',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 9})">"gemeinsam Verantwortlichen nach Art. 26 DSGVO."</a> </p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 41,
      inquiry: 'Sollen durch das zu entwickelnde System auch regelmäßig Daten unter 16-Jähriger verarbeitet werden?',
      subject: 'Frage-ID 504',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 30})">"Art. 8 Abs. 1 DSGVO."</a> </p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 41.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 41.1,
      inquiry: 'Können Vorkehrungen getroffen werden, um sicherzustellen, dass eine notwendige Einwilligung von den Träger*Innen der elterlichen Verantwortung eingeholt wird?',
      subject: 'Frage-ID 504.1',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 31})">"Art. 8 Abs. 2 DSGVO."</a> </p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 42,
      inquiry: 'Werden durch die zu entwicklende MTI regelmäßig sensible Daten verarbeitet?',
      subject: 'Frage-ID 505',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 14})">Sensiblen Daten" nach Art. 9 Abs. 1 DSGVO."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 42.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 42.1,
      inquiry: 'Besteht eine technische Möglichkeit zur Erteilung einer Einwilligung oder liegt eine sonstige gesetzliche Ausnahme vor?',
      subject: 'Frage-ID 505.1',
      message: '<p>Zu gesetzlichen Ausnahmen siehe: <a @click.prevent="$emit(\'kblink\', {id: 32})">"Art. 9 Abs. 2 lit. a DSGVO."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 43,
      inquiry: 'Wird berücksichtigt, dass eine ausschließlich auf einer automatisierten Verarbeitung beruhende Entscheidung, die gegenüber einem Betroffenen rechtliche Wirkung entfaltet oder ihn in ähnlicher Weise erheblich beeinträchtigt, grundsätzlich unzulässig ist?',
      subject: 'Frage-ID 506',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 33})">"Art. 22 Abs. 1 DSGVO."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 44,
      inquiry: 'Sofern ein hohes datenschutzrechtliches Risiko bestünde, erschiene eine Datenschutz-Folgenabschätzung notwendig oder sinnvoll?',
      subject: 'Frage-ID 507',
      message: '<p>Zur<a @click.prevent="$emit(\'kblink\', {id: 34})">"Datenschutz-Folgenabschätzung."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 44.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 44.1,
      inquiry: 'Werden diesbezüglich technische Maßnahmen geplant, um erhöhte datenrechtliche Maßnahmen zu minimieren?',
      subject: 'Frage-ID 507.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 45,
      inquiry: 'Wird die Datenverarbeitung voraussichtlich (auch) unter Nutzung instituts- oder projektfremder Infrastruktur durchgeführt (z. B. Dritt-Server, Open Access-Plattformen, Cloud-Services)?',
      subject: 'Frage-ID 508',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 45.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 45.1,
      inquiry: 'Sind technische Maßnahmen geplant, um insofern hinreichenden Datenschutz sowie eine erforderliche Datensicherheit zu gewährleisten?',
      subject: 'Frage-ID 508.1',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 26})">"Datenschutz"</a>, zu <a @click.prevent="$emit(\'kblink\', {id: 25})">"Datensicherheit."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 46,
      inquiry: 'Finden bei einem Einsatz der zu entwickelnden MTI voraussichtlich Vorgänge von Datenermittlungen in Drittländer außerhalb der EU statt?',
      subject: 'Frage-ID 509',
      message: '<p>Zu<a @click.prevent="$emit(\'kblink\', {id: 35})">"Art. 13 Abs. 1 lit. f DSGVO."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 46.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 46.1,
      inquiry: 'Sind technische Maßnahmen geplant, um insofern hinreichenden Datenschutz sowie eine erforderliche Datensicherheit zu gewährleisten?',
      subject: 'Frage-ID 509.1',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 26})">"Datenschutz"</a>,zu <a @click.prevent="$emit(\'kblink\', {id: 25})">"Datensicherheit."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 47,
      inquiry: 'Ist den Antragstellenden bekannt, dass auch eine unzureichende/fehlerhafte Software-Architektur eines IT-Produkts Haftungs- oder Gewährleistungsansprüche auslösen kann?',
      subject: 'Frage-ID 510',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 48,
      inquiry: 'Ist beabsichtigt, dass sämtliche personenbezogenen Daten der Anwendenden innerhalb des Systems verbleiben und nicht für Dritte zugänglich sind?',
      subject: 'Frage-ID 511',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', followupID: 48.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 48.1,
      inquiry: 'Wird durch technische Vorkehrungen sichergestellt, dass der Datenschutz und die Datensicherheit gewährleistet werden?',
      subject: 'Frage-ID 511.1',
      message: '<p><p>Zu <a @click.prevent="$emit(\'kblink\', {id: 26})">"Datenschutz"</a>, zu <a @click.prevent="$emit(\'kblink\', {id: 25})">"Datensicherheit."</a></p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 49,
      inquiry: 'Ist es betroffenen Personen möglich, eine Auskunft zur Verarbeitung ihrer personenbezogener Daten zu verlangen?',
      subject: 'Frage-ID 512',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 49.1, risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 49.1,
      inquiry: 'Werden in der Anwendung technische Vorkehrungen getroffen, damit einem Auskunftsverlangen des Betroffenen zur Verarbeitung seiner*ihrer personenbezogenen Daten unkompliziert entsprochen werden kann?',
      subject: 'Frage-ID 512.1',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 50,
      inquiry: 'Ist die Einwilligung in die Datenverarbeitung für Betroffene jederzeit widerrufbar?',
      subject: 'Frage-ID 513',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 50.1, risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 50.1,
      inquiry: 'Werden in der Anwendung technische Vorkehrungen getroffen, damit eine erklärte Einwilligung in die Datenverarbeitung jederzeit widerrufen und ein Widerspruch berücksichtigt werden kann?',
      subject: 'Frage-ID 513.1',
      message: '<p>Zu<a @click.prevent="$emit(\'kblink\', {id: 37})">"Art. 7 Abs. 3 DSGVO"</a> und <a @click.prevent="$emit(\'kblink\', {id: 38})">"Art. 21 Abs. 6 DSGVO."</a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 51,
      inquiry: 'Ist bekannt, dass nicht nur das übermäßige Sammeln und Verarbeiten von Daten, sondern auch das rechtswidrige Löschen oder Vernichten von Daten strafrechtlich relevant sein kann?',
      subject: 'Frage-ID 514',
      message: '<p>Zum Sammeln und Verarbeiten:<a @click.prevent="$emit(\'kblink\', {id: 39})">"§202a StGB"</a>,zum "Löschen und Vernichten:<a @click.prevent="$emit(\'kblink\', {id: 40})">§303a StGB"</a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 52,
      inquiry: 'Ist bekannt, dass eine bezüglich Datensicherheit schlecht oder unzureichend gestaltete Software oder Anwendung Schadensersatzansprüche auslösen kann, die sich auf sogenannte Folgeschäden erstrecken können?',
      subject: 'Frage-ID 515',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 41})">"§ 823 Abs. 1 BGB"</a> und <a @click.prevent="$emit(\'kblink\', {id: 42})">"§ 1 Abs. 1 ProdHaftG"</a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 53,
      inquiry: 'Ist den Antragstellenden bekannt, dass nicht lediglich der Schutz personenbezogener Daten, sondern ebenso der Grundsatz der "Sicherheit der Verarbeitung" in der DSGVO normiert und durch weitere Vorgaben konkretisiert wird?',
      subject: 'Frage-ID 516',
      message: '<p>Zu<a @click.prevent="$emit(\'kblink\', {id: 43})">"Art. 5 Abs. 1 lit f. DSGVO </a>i. V. m.<a @click.prevent="$emit(\'kblink\', {id: 44})">"Art. 32 DSGVO </a></p>',
      isStarred: false,
      labels: ['Allgemein','Datenschutz','Schadensvermeidung','Autonomie','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 54,
      inquiry: 'Handelt es sich bei dem zu entwickelnden Produkt um ein informationstechnisches System oder um Komponenten hiervon für Einrichtungen des Bundes?',
      subject: 'Frage-ID 601',
      message: '<p></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 54.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 54.1,
      inquiry: 'Ist den Antragstellenden bekannt, dass hiermit auch bestimmte Pflichten des Herstellers verbunden wären?',
      subject: 'Frage-ID 601.1',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 45})">"§ 5a Abs. 6 BSIG</a></p>',
      isStarred: false,
      labels: ['Allgemein','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },

    {
      id: 55,
      inquiry: 'Handelt es sich bei dem zu entwickelnden Produkt um einen digitalen Dienst?',
      subject: 'Frage-ID 602',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 46})">"einem digitalen Dienst.</a> </p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 55.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },

    {
      id: 55.1,
      inquiry: 'Sind die besonderen Anforderungen an deren Anbieter bekannt?',
      subject: 'Frage-ID 602.1',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 47})">"§ 8c BSIG. </a></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 1},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 56,
      inquiry: 'Handelt es sich bei dem zu entwickelnden Produkt um ein System, welches in Kritischen Infrastrukturen (KRITIS) eingesetzt werden kann?',
      subject: 'Frage-ID 603',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 22})">Kritischen Infrastrukturen.</a></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'followup-radio',
        options: [
          {name: 'Ja', followupID: 56.1, risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 56.1,
      inquiry: 'Hält das Produkt technische Vorkehrungen zur Schadensvermeidung vor?',
      subject: 'Frage-ID 603',
      message: '<p>Zu <a @click.prevent="$emit(\'kblink\', {id: 48})">"§ 8b Abs. 4 BSIG. </p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
          ],
        answer: '',
      },
      remark: '',
    },
    {
      id: 57,
      inquiry: 'Hält das Produkt technische Vorkehrungen zur Schadensvermeidung vor (z. B. automatisierte Aufzeichnungs-, Melde-/Informationsvorgänge)?',
      subject: 'Frage-ID 604',
      message: '<p>Zu<a @click.prevent="$emit(\'kblink\', {id: 49})">"§ 8a Abs. 1 BSIG.</a></p>',
      isStarred: false,
      labels: ['Allgemein','Fürsorge','Schadensvermeidung','Transparenz'],
      time: '',
      folder: 'inbox',
      isTrashed: false,
      trashingReason: '',
      answer: {
        type: 'radio',
        options: [
          {name: 'Ja', risk_contemplation: 0, risk_existence: 0, risk_addressing: 0},
          {name: 'Nein', risk_contemplation: 0, risk_existence: 1, risk_addressing: 0},
        ],
        answer: '',
      },
      remark: '',
    },
  ],

  // Tags and labels
  mailTags: [
    {text: 'Allgemein', value: 'Allgemein', color: '#5E5E5F'},
    {text: 'Datenschutz', value: 'Datenschutz', color: '#5E5E5F'},
    {text: 'Tue Gutes', value: 'Fürsorge', color: '#333333'},
    {text: 'Tue niemandem weh', value: 'Schadensvermeidung', color: '#333333'},
    {text: 'Bewahre die menschliche Handlungsfähigkeit', value: 'Autonomie', color: '#333333'},
    {text: 'Sei fair', value: 'Gerechtigkeit', color: '#333333'},
    {text: 'Funktioniere', value: 'Transparenz', color: '#333333'},
  ],

  // Sidebar-filter for state (inbox, answered) and labels.
  mail_filter: null,
  meta: {},
  project: {
    nameApplicant: '',
    nameProject: '',
  },
  mailSearchQuery: '',
}

